import { type AnalyticsResponse } from '../../services/api/analytics';
import { CHANNEL_COLORS, CHANNEL_BG, CHANNEL_LABEL } from './analytics.constants';

interface Props {
  data: AnalyticsResponse;
  channels: string[];
}

export const AnalyticsChannelBreakdown = ({ data, channels }: Props) => (
  <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
    <h3 className="text-sm font-semibold text-slate-900 mb-4">Kanalfördelning</h3>
    <div className="space-y-4">
      {[...channels]
        .sort((a, b) => (data.totals.byChannel[b] ?? 0) - (data.totals.byChannel[a] ?? 0))
        .map((channel) => {
          const count = data.totals.byChannel[channel] ?? 0;
          const pct = data.totals.total > 0 ? (count / data.totals.total) * 100 : 0;
          return (
            <div key={channel}>
              <div className="flex items-center justify-between mb-1.5">
                <div className="flex items-center gap-2">
                  <div
                    className="h-2.5 w-2.5 rounded-full"
                    style={{ backgroundColor: CHANNEL_COLORS[channel] ?? '#94a3b8' }}
                  />
                  <span className="text-sm font-medium text-slate-700">
                    {CHANNEL_LABEL[channel] ?? channel}
                  </span>
                </div>
                <span className="text-sm text-slate-500">
                  {count.toLocaleString('sv-SE')} ({Math.round(pct)}%)
                </span>
              </div>
              <div className="h-2 w-full rounded-full bg-slate-100 overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all duration-500 ${CHANNEL_BG[channel] ?? 'bg-slate-400'}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
            </div>
          );
        })}
    </div>
  </div>
);
